<template>
  <div class="expnad-box">
    <div class="expand-box-header">
      <div @click="onExpand" class="expand-box-header--title">
        <img
          v-show="chevronIcon"
          :src="arrowIcon"
          class="dt-icon v5 s1"
          alt=""
        />
        {{ title }}
      </div>
      <div class="expand-icon">
        <div class="minus-parent" @click="onExpand">
          <div class="dt-icon-container">
            <img @click.stop="onExpand" :src="iconSrc" class="dt-icon v5 s1" />
          </div>
        </div>
      </div>
    </div>
    <div class="expnad-box-body">
      <transition name="slide">
        <div v-show="expand">
          <slot name="body"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    name: {
      type: String,
    },
    selected: {
      type: Boolean,
    },
    maximized: {
      type: Boolean,
      default: false,
    },
    isPinnable: {
      type: Boolean,
    },
    chevronIcon: {
      type: Boolean,
    },
  },
  mounted() {
    // this.expand = !this.maximized;
    if (this.maximized) {
      this.expand = true;
    }
  },
  data: () => ({
    expand: false,
  }),
  computed: {
    iconSrc: function () {
      return this.expand
        ? "static/icons/minus.svg"
        : "static/icons/plus/plus-grau.svg";
    },
    arrowIcon: function () {
      return this.expand
        ? "static/icons/arrows/chevron-up.svg"
        : "static/icons/arrows/chevron-down.svg";
    },
  },
  methods: {
    onExpand: function () {
      this.expand = !this.expand;
      this.$emit("expanded", this.expand);
    },
  },
};
</script>

<style lang="scss">
.expnad-box {
  .expand-box-header {
    height: 30px;
    display: flex;
    border-bottom: 1px solid var(--sprt-7);
    //  padding: 10px 10px 10px 10px;
    .expand-icon {
      flex: 0.05;
      // margin-top: 15px;
      // margin-left: 10px;
      .minus-parent {
        padding: 1px;
        // background-color:white;

        display: flex;
        // width:12px;
        justify-content: center;

        cursor: pointer;

        &.selected {
          // background-color:var(--sprt-7);
        }
      }
      .minus-child {
        height: 1px;
        min-width: 6px;
      }
    }

    .expand-box-header--title {
      padding: 4px 10px;

      font-weight: 600 !important;
      flex: 0.95;
      border-right: 1px solid var(--sprt-7);
      cursor: pointer;
    }
  }

  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.3s;
  }
  .slide-enter,
  .slide-leave-to {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>
